<template>
    <div class="p-4 w-full h-full relative overflow-hidden">
        <WFScrollableArea class="">
            <div class="grid grid-cols-2 gap-x-24 gap-y-12 p-36">
                <div v-for="article in news" v-bind:key="article.url" class="card card-border border-2 th-border">
                    <div class="card-body flex justify-between">
                        <div class="h-340 w-340 grow-0 shrink-0 overflow-hidden">
                            <img loading="lazy" :src="article.imageOptimized" class="h-340 w-340 object-cover">
                        </div>
                        <div class="p-34 flex flex-col justify-between grow-1 article-bg">
                            <div class="flex flex-col gap-16">
                                <label class="text-16">{{ article.strdate }}</label>
                                <h2 class="card-title text-28 text-bold" v-html="article.heading"></h2>
                            </div>
                            <div>
                                <button @click="clicked(article)" class="th-btn th-btn-active"><WFTranslate k="news-more"></WFTranslate></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </WFScrollableArea>
        <div v-if="!!activeArticle" class="absolute top-0 bottom-0 left-0 rigt-0 w-full bg-base flex gap-100">
            <div class="h-full w-3/7 grow-0 shrink-0">
                <img :src="activeArticle.imageOptimized" class="h-full w-full object-cover">
            </div>
            <WFScrollableArea>
                <div class="flex flex-col gap-16 p-16">
                    <label class="text-16">{{ activeArticle.strdate }}</label>
                    <h2 class="card-title text-28 text-bold" v-html="activeArticle.heading"></h2>
                    <section class="text-16" v-html="activeArticle.description">

                    </section>
                </div>
            </WFScrollableArea>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { WFScrollableArea } from '@3dwayfinder/wayfinder-vue-components'

export default {
    components: {
		WFScrollableArea,
        
    },
    computed: {
		...mapState(['news', 'goback']),
	},
    data() {
        return {
            activeArticle: null
        }
    },
    watch: {
        goback() {
            this.activeArticle = null;
        },
    },
    methods: {
        clicked (article) {
            this.activeArticle = article;
            this.$store.dispatch("setNavbar", true);
        }
    }
}
</script>

<style lang="postcss">
    .article-bg {
        background-image: url("@/assets/item_bg.svg");
        background-size: cover;
    }
</style>